import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {RegisterService} from "../services/register.service";
import {environment} from "../environments/environment";
import {CustomDatePipe} from "../shared/custom.datepipe";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ActivatedRoute, ParamMap, Router} from "@angular/router";
//import {DomSanitizer} from "@angular/platform-browser";
import {DeviceDetectorService} from "ngx-device-detector";
//import {Channel} from "../channel";
//import {ChannelService} from "../channel.service";

@Component({
  selector: 'app-cancelservice',
  standalone: true,
  imports: [
    ReactiveFormsModule
  ],
  templateUrl: './cancelservice.component.html'
})
export class CancelserviceComponent implements OnInit {
  // channels = new Array();
  private page = "";
  private countryCode = "de";
  newsletterImage = "";
  cancelImage = "";
  stickImage = "";
  deButton = "";
  amcLogoImage = "";
  fieldLabel;
  fieldLabel2;
  amcUnsubForm: FormGroup;
  amcUnsubFormLabel: FormGroup;
  translateData = [];
  language = { key: ["de"] };
  serviceId = "-1";
  medium = "newsletter";
  private serviceLabel: string;
  public check: boolean = false;

  /**
   * @brief getCurrentPage()
   * @param -
   * @return -
   * @details function to get the current page
   */
  public getCurrentPage() {
    return this.page;
  }

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private registerService: RegisterService,
    private route: ActivatedRoute,
//    private sanitized: DomSanitizer,
    @Inject(PLATFORM_ID) private _platformId: Object,
//    private channelService:ChannelService
  ) {
    this.newsletterImage = environment.newsletterImage;
    this.stickImage = environment.stickImage;
    this.deButton = environment.amcLogoImage;
    this.amcLogoImage = environment.amcLogoImage;
    this.cancelImage = environment.cancelImage;
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.countryCode = params.get("lang");
    });

    if (this.countryCode == null) {
      this.countryCode = "de";
    }
/*
    this.channelService.getJSON().subscribe(response =>{
      this.channels = response.map( item =>
        {
          return new Channel(
            item.id,
            item.channel,
            item.service
            );
        });
    });
*/
    let ParamValue;
    if (this.route.snapshot.queryParams["nl"]) {
      ParamValue = this.route.snapshot.queryParams["nl"];
    } else if (this.route.snapshot.queryParams["service"]) {
      ParamValue = this.route.snapshot.queryParams["service"];
    }

    switch (ParamValue.toUpperCase()) {
      case "0":
      case "MS":
        this.serviceId = "0";
        this.medium = "marketing service";
        this.serviceLabel = "unsub";
        break;
      case "1":
      case "NL":
        this.serviceId = "1";
        this.medium = "newsletter";
        this.serviceLabel = "nl_unsub";
        break;
      case "2":
      case "IS":
        this.serviceId = "2";
        this.medium = "information service";
        this.serviceLabel = "unsub_is";
        break;
      default:
        this.serviceId = "-1";
    }

    this.loadTranslateDataFromDB(this.countryCode);

    /**
     * Definition of form fields for unsubscriber
     */
    this.amcUnsubForm = this.formBuilder.group({
      oo_classId: ["4"],
      email: [""],
      nl: [this.serviceId],
      isNewsletter: [this.serviceId],
      medium: [this.medium],
      token: ["inactive"],
      submittedTime: [this.getCustomDate()],
      subscriberLanguage: [this.countryCode],
      browser: [this.getBrowserInfo()],
      campaignCode: [""],
      treatmentCode: [""],
      individualHash: [""],
      countryNumber: [this.countryCode],
      supplierId: ["99"],
      active: ["1"],
      all: [false],
      email_nl: [false],
      email_ms: [false],
      email_is: [false],
      post: [false],
      phone: [false],
    });

    /**
     * Definition of form field-labels for frontend
     */
    this.amcUnsubFormLabel = this.formBuilder.group({
      nl_email: ["E-Mail"],
      nl_unsub_btn: ["Abmelden"],
      nl_unsub_btn_is: ["Abmelden"],
      nl_heading: ["AMC Newsletter"],
      nl_heading_ms: ["AMC Specials"],
      nl_heading_is: ["AMC Info"],
      nl_unsub: [
        "Sie möchten sich von den AMC News abmelden? Tragen Sie bitte Ihre E-Mail Adresse ein:",
      ],
      unsub: [
        "Sie möchten in Zukunft keine Informationen zu den Produkten von AMC mehr erhalten? Tragen Sie bitte Ihre E-Mail Adresse ein:",
      ],
      unsub_is: [
        "Sie möchten in Zukunft keine allgemeine Informationen von AMC erhalten? Bitte geben Sie ihre E-Mail Adresse ein:",
      ],
      nl_success_unsub: ["Sie haben sich erfolgreich abgemeldet"],
      nl_warning_mail_not_sent: [
        "Aufgrund eines Fehlers konnte keine Email verschickt werden. Bitte versuchen Sie es erneut.",
      ],
      nl_continue: ["Zurück"],
      nl_err: ["Bitte überprüfen Sie Ihre Eingabe"],
      nl_err_btn: ["Bitte überprüfen Sie Ihre Eingabe"],
    });
  }

  getFieldContent(field) {
    return this.amcUnsubForm.get(field);
  }

  getServiceLabel() {
    return this.getFieldLabel(this.serviceLabel);
  }

  getFieldLabel(Label) {
    if (Label == "nl_unsub_btn" && this.serviceId == "2") {
      Label = "nl_unsub_btn_is";
    }

    // New Heading for Marketing Service
    if (Label == "nl_heading" && this.serviceId == "0") {
      Label = "nl_heading_ms";
    }

    // New Heading for Information Service
    if (Label == "nl_heading" && this.serviceId == "2") {
      Label = "nl_heading_is";
    }

    this.fieldLabel2 = this.amcUnsubFormLabel.get(Label);
    return this.fieldLabel2 != null ? this.fieldLabel2.value : "";
  }

  getBrowserInfo() {
    let deviceService = new DeviceDetectorService(this._platformId);
    return deviceService.browser + " V(" + deviceService.browser_version + ")";
  }

  /**
   * Get translated data from the database from register.service.ts
   * @param language
   */
  loadTranslateDataFromDB(language) {
    this.translateData = [];
    this.language.key = language;
    this.registerService.loadTranslateDataFromDB(this.language.key).subscribe(
      (data) => {
        this.translateData = data;
        this.setTranslate();
        if (this.serviceId == "-1") {
          this.router.navigate(["./" + this.countryCode + "/error/nms"]);
        }
      },
      (error) => {
        this.router.navigate(["./" + this.countryCode + "/error/nms"]);
      }
    );
  }

  /**
   * Set labels with translated texts from the database
   */
  setTranslate() {
    this.translateData.forEach((obj) => {
      this.fieldLabel = this.translateData.find((k) => k.key === obj.key);
      if (
        this.fieldLabel != null &&
        this.amcUnsubFormLabel.get(obj.key) != null
      ) {
        this.amcUnsubFormLabel.controls[obj.key].setValue(this.fieldLabel.text);
      }
    });
  }

  isOneChecked()
  {
    return !!(this.getFieldContent("all").value ||
      this.getFieldContent("email_nl").value ||
      this.getFieldContent("email_is").value ||
      this.getFieldContent("post").value ||
      this.getFieldContent("phone").value);
  }

  /**
   * Submit unsubscription data to backend
   */
  onSubmitUnsub() {
    if (this.isOneChecked()) {
      this.registerService.unsubscribe(this.amcUnsubForm.value).subscribe(
        (response) => {
          if (response["response"] == "unsubsuccess") {
            this.router.navigate(["./" + this.countryCode + "/unsubsuccess"]);
          } else {
            this.router.navigate(["./" + this.countryCode + "/error/nms"]);
          }
        },
        (error) => {
          this.router.navigate(["./" + this.countryCode + "/error/nms"]);
        }
      );
    }
  }

  /**
   * Submit unsubscription data to backend
   */
  /*
  onSubmitUnsubAll() {
    if (this.channels.length) {
      this.registerService.unsubscribeAll(this.channels).subscribe(
        (response) => {
          if (response["response"] == "unsubsuccess") {
            this.router.navigate(["./" + this.countryCode + "/unsubsuccess"]);
          } else {
            this.router.navigate(["./" + this.countryCode + "/error/nms"]);
          }
        },
        (error) => {
          this.router.navigate(["./" + this.countryCode + "/error/nms"]);
        }
      );
    }
  }
   */

  /**
   * get custom date format for database
   */
  getCustomDate(dateFormat?: any) {
    let customDatePipe = new CustomDatePipe("en-US");
    return customDatePipe.transform(new Date(), dateFormat);
  }

  resetCheckBox(val: boolean){
    this.amcUnsubForm.patchValue({ email_nl: val });
    this.amcUnsubForm.patchValue({ email_ms: val });
    this.amcUnsubForm.patchValue({ email_is: val });
    this.amcUnsubForm.patchValue({ post: val });
    this.amcUnsubForm.patchValue({ phone: val });
  }

  isAllChecked() {
    if(!this.getFieldContent("email_nl").value)  return  false;
    if(!this.getFieldContent("email_ms").value) return  false;
    if(!this.getFieldContent("email_is").value) return  false;
    if(!this.getFieldContent("post").value) return  false;
    if(!this.getFieldContent("phone").value) return  false;

    return true;
  }

  checkAllCheckBox($event: Event) {
    if(this.getFieldContent("all").value){
      this.resetCheckBox(true);
    } else {
      this.resetCheckBox(false);
    }
  }
}
